import CollaboratorService from '../../services/CollaboratorService';
import collaboratorUseCase from './collaboratorUseCase';

const collaboratorFactory = collaboratorUseCase({
  CollaboratorService: CollaboratorService(),
});

export default collaboratorFactory;
